module.exports = __webpack_public_path__ + "static/img/73.d2cb8e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/Teams/73.png
// module id = jWj0
// module chunks = 1